<gen-button
    [type]="'split'"
    [text]="defaultButtonText"
    [tag]="tag"
    [iconClass]="iconClass + ' fs4_5'"
    (click)="buttonClick()"
    (dropdownVisibilityChanged)="dropdownVisibilityChanged($event)">
  <gen-external-search-details
      [buttonText]="panelButtonText"
      [data]="data"
      [searchFormConfigParams]="searchFormConfigParams"
      [searchDataConfigParams]="searchDataConfigParams"
      [searchURL]="searchURL"
      [shown]="panelShown">
  </gen-external-search-details>
</gen-button>